<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'saleRefundList',
          title: '销售退货列表'
        },
        {
          name: 'saleRefundAdd',
          title: '销售退货单'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="content">
        <lk-card title="退货单信息" class="other-card">
          <lk-form
            ref="saleRefundForm"
            :label-width='134'
            label-position="right"
            :model="saleRefund"
            :rules="saleRefundRules">
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="退回商品:">
                  <lk-button type="primary" @click="showAddRejectGoods">选择订单</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="23">
                <lk-form-item>
                  <lk-table :data="tableData" :columns="rejectColumn" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="退货金额合计:">
                  <span>{{sumMoney}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" >
                <lk-form-item label="退款合计:">
                  <span>{{refundTotal}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="10">
                <lk-form-item label="退款信息:" >
                  <div v-for="(refundItem, index) in refundList" :key="index">
                    <div class="refundMethod">
                      <lk-select placeholder='请选择退款方式'  class="refundInput" v-model="refundItem.proceedsTypeId" label-in-value :clearable="refundData.length > 0" @on-change="handleProceedsTypeChange(refundItem, index)">
                      <lk-option v-for="item in proceedsTypeList" :value="item.proceedsTypeId" :key="item.proceedsTypeName">{{ item.proceedsTypeName }}
                        </lk-option>
                      </lk-select>
                      &nbsp;
                      <lk-input-number style="width:calc(50% - 25px)" v-model.trim="refundItem.amount" :max="999999999.99" :min="0" :active-change="false" placeholder='请输入退款金额' clearable @on-change="priceChange" :precision="2" ></lk-input-number>
                      <lk-button v-if="index!=0" type="text-primary" @click="deleteRefund(index)">删除</lk-button>
                      <div class="emptySpan" v-else></div>
                    </div>
                  </div>
                  <span v-if="refundList.length < 5" class="addButton" @click="addNew">+添加退款方式</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16' v-if="refundData.length>0">
              <lk-col span="23">
                <lk-form-item label="预收核销退回:">
                  <lk-table :data="refundData" :columns="refundColum" class="rejectTable" border/>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收记录:" prop="inspectRecord">
                  <lk-input type="textarea" placeholder="请输入" v-model.trim="saleRefund.inspectRecord"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="验收人员:" prop="refundInspector">
                  <lk-input placeholder="请输入" v-model.trim="saleRefund.refundInspector"></lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <an-spin v-if="loading"/>
    <ReturnGoodsModal :show="ModalShow" @cancel="onAddRejectGoodsModalCancel" @ok="onAddRejectGoodsOk" :selectedTable="selected"/>
    <DTPModal
      v-model="changeGoods"
      content="重新选择商品将清空已选商品，是否确定？"
      @confirm="doChangeGoods"
      @handleCancel="cancelChangeGoods">
    </DTPModal>
  </div>
</template>

<script>

import _ from 'lodash';
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';
import AddReturnExpand from './AddReturnExpand.vue';
import ReturnGoodsModal from './ReturnGoodsModal';
import afterSale from '../../services/afterSale';
import system from '../../services/system';
import AnSpin from '../../components/AnSpin.vue';
import DTPModal from '../../components/DTPModal';
// import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'saleRefundAdd',
  components: {
    BaseFrame,
    // AnTable,
    ReturnGoodsModal,
    AnSpin,
    DTPModal,
  },
  data() {
    return {
      refundList: [],
      loading: false,
      sumMoney: 0,
      inventoryArr: [],
      ModalShow: false,
      changeGoods: false,
      refundTotal: 0,
      addRejectValidate: {
        goodsId: [
          {
            required: true, message: '请选择商品', trigger: 'blur', type: 'number',
          },
        ],
        rejectNum: [
          {
            required: true, message: '请输入拒收数量', trigger: 'blur',
          },
        ],
        rejectReason: [
          {
            required: true, message: '请输入拒收原因', trigger: 'blur',
          },
        ],
      },
      addRejectGoodsModalShow: false,
      refundData: [],
      refundColum: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '收款单号',
          minWidth: 116,
          key: 'depositCode',
        },
        {
          title: '付款人',
          minWidth: 116,
          key: 'paymentUserName',
        },
        {
          title: '联系方式',
          minWidth: 116,
          key: 'paymentUserPhone',
        },
        {
          title: '核销金额',
          minWidth: 116,
          key: 'verificationAmount',
        },
        {
          title: '已退款金额',
          minWidth: 116,
          key: 'refundedAmount',
          render: (h, params) => h('span', params.row.refundedAmount ? params.row.refundedAmount : '0'),
        },
        {
          title: '退款中金额',
          minWidth: 116,
          key: 'refundingAmount',
          render: (h, params) => h('span', params.row.refundingAmount ? params.row.refundingAmount : '0'),
        },
        {
          title: '可退款金额',
          minWidth: 116,
          key: 'ableToRefundAmount',
        },
        {
          title: '退款金额',
          minWidth: 130,
          render: (h, { row, index }) => h('lk-input-number', {
            on: {
              'on-change': (e) => {
                this.refundData[index].refundAmount = e;
                if (e * 1 > this.refundData[index].verificationAmount * 1) {
                  this.$Message.error('预收退款金额不能大于可退款金额');
                  return;
                }
                this.priceChange();
              },
            },
            props: {
              value: row.refundAmount,
              placeholder: '退款金额',
              min: 0,
              precision: 2,
              max: row.ableToRefundAmount * 1,
              'active-change': false,
            },
          }),
        },
      ],
      rejectColumn: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(AddReturnExpand,
            {
              props: {
                row,
              },
            }),
        },
        {
          title: '序号',
          minWidth: 80,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '销售单号',
          minWidth: 116,
          key: 'orderNo',
        },
        {
          title: '商品名称',
          minWidth: 116,
          key: 'goodsName',
        },
        {
          title: '单价',
          minWidth: 116,
          key: 'refundPrice',
          render: (h, { row }) => h('span', row.refundPrice),
        },
        {
          title: '销售数量',
          minWidth: 116,
          key: 'goodsCount',
        },
        {
          title: '可退货数量',
          minWidth: 116,
          key: 'refundableNum',
        },
        {
          title: '仓库/货位',
          minWidth: 116,
          render: (h, { row, index }) => {
            const inventoryArr = this.walkTree(row.refundableWarehouseLocationList);
            return h('lk-cascader', {
              on: {
                'on-change': (value, selectData) => {
                  this.changeInventory(index, value, selectData);
                },
              },
              props: {
                value: row.inventory,
                data: inventoryArr,
              },
            });
          },
        },
        {
          title: '退货数量',
          minWidth: 130,
          render: (h, { row, index }) => {
            if(row.isMarketingPromote) {
              this.tableData[index].refundNum = row.refundableNum;
              this.tableData[index].refundAmount = Number(utils.toFixed(this.tableData[index].refundPrice * row.refundableNum, 2, true), 10);
              this.generateSum();
            }
            return !row.isMarketingPromote ? h('lk-input-number', {
              on: {
                'on-change': (e) => {
                  const num = e;
                  this.tableData[index].refundNum = num;
                  this.tableData[index].refundAmount = Number(utils.toFixed(this.tableData[index].refundPrice * num, 2, true), 10);
                  this.generateSum();
                },
              },
              props: {
                value: row.refundNum,
                placeholder: '数量',
                min: 0,
                precision: 2,
                max: 1000000000,
                'active-change': false,
              },
            }) : h('span', row.refundableNum);
          }
        },
        {
          title: '退货金额',
          minWidth: 130,
          key: 'refundAmount',
        },
        {
          title: '退货原因',
          minWidth: 130,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.tableData[index].refundReason = e.target.value;
              },
            },
            props: {
              value: row.refundReason,
              placeholder: '原因',
            },
          }),
        },
        {
          title: '操作',
          width: 116,
          render: (h, params) => h('lk-button',
            {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.onDelete(params.row.isMarketingPromote, params.index);
                },
              },

            }, '删除'),
        },
      ],
      tableData: [],
      proceedsTypeList: [],
      saleRefund: {
        inspectRecord: null,
        refundInspector: null,
      },
      saleRefundRules: {
        inspectRecord: [
          {
            required: true,
            message: '请输入验收记录',
          },
        ],
        refundInspector: [
          {
            required: true,
            message: '请输入验收人员',
          },
        ],
      },
    };
  },
  computed: {
    selected() {
      return this.tableData.map(item => item.id);
    },
  },
  methods: {
    priceChange() {
      let sum = 0;
      for (let i = 0; i < this.refundList.length; i++) {
        if (this.refundList[i].amount && this.refundList[i].amount != undefined) {
          sum += this.refundList[i].amount * 1;
        }
      }
      for (let i = 0; i < this.refundData.length; i++) {
        if (this.refundData[i].refundAmount != undefined && this.refundData[i].refundAmount) {
          sum += this.refundData[i].refundAmount * 1;
        }
      }
      this.refundTotal = utils.toFixed(sum, 2, true);
    },
    deleteRefund(index) {
      this.refundList.splice(index, 1);
      this.priceChange();
    },
    addNew() {
      const temp = { proceedsTypeId: null, amount: null };
      if (this.refundList.length <= 0) {
        this.refundList = [{ proceedsTypeId: null, amount: null }];
      } else {
        this.refundList.push(temp);
      }
    },
    onDelete(isMarketingPromote, index) {
      if (isMarketingPromote) {
        this.tableData = [];
      } else {
        this.tableData.splice(index, 1);
        this.generateSum();
      }
    },
    generateSum() {
      const sum = this.tableData.reduce((acc, current) => acc + current.refundAmount * 1, 0);
      this.sumMoney = utils.toFixed(sum, 2, true);
    },
    changeInventory(index, value, selectData) {
      if (value.length <= 1) {
        this.$Message.error('请选择货位');
        return;
      }
      const [warehouse, locationItem] = selectData;
      this.tableData[index].wareHouseName = warehouse.warehouseName;
      this.tableData[index].wareHouseId = warehouse.warehouseId;
      this.tableData[index].locationId = locationItem.locationId;
      this.tableData[index].locationCode = locationItem.locationCode;
      this.tableData[index].inventory = value;
    },
    onAddRejectGoodsOk(selection) {
      this.ModalShow = false;
      this.tableData = [];
      let orderCode = '';
      selection.forEach((resItem) => {
        const tempItem = Object.assign({}, resItem);
        tempItem.refundPrice = tempItem.realPrice;
        tempItem.refundNum = null;
        tempItem.refundReason = '';
        tempItem.refundAmount = '';
        this.tableData.push(tempItem);
        orderCode = tempItem.orderNo;
      });
      if (selection.length > 0) {
        this.getPayMethod(orderCode);
        this.getProceedsTypeList();
      }
    },
    getPayMethod(value) {
      afterSale.getPayMethod({ orderNo: value }).then((res) => {
        if (res.data.status == 200) {
          if (res.data.data.financeDepositInfos != undefined) {
            this.refundData = res.data.data.financeDepositInfos;
            this.refundData.forEach((item) => {
              if (!item.refundAmount) {
                item.refundAmount = null;
              }
            });
          }
          if (res.data.data.saleOrderProceeds != undefined) {
            this.refundList = res.data.data.saleOrderProceeds;
          } else {
            this.refundList = [{ proceedsTypeId: null, amount: null }];
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.loading = false;
        this.priceChange();
      });
    },
    resetTableData() {
      this.tableData = [];
      this.refundMethod = [];
      this.refundData = [];
    },
    showAddRejectGoods() {
      if (this.tableData.length > 0) {
        this.changeGoods = true;
      } else {
        this.ModalShow = true;
      }
    },
    onAddRejectGoodsModalCancel() {
      this.ModalShow = false;
    },
    // eslint-disable-next-line func-names
    onBtnClick: _.throttle(function (name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'submit') {
        this.onSubmit();
      }
    }, 3000),
    onSubmit() {
      this.$refs.saleRefundForm.validate((valid) => {
        if (valid) {
          let data = {};
          let saleRefundDetailVoList = [];
          let noGoods = false;
          let dataIsNotFull = false;
          let numNotValidate = false;

          saleRefundDetailVoList = this.tableData.map((item) => {
            if (!item.refundNum || !item.refundReason.trim() || !item.wareHouseId || !item.locationId) {
              dataIsNotFull = true;
            }
            if ((Number.isNaN(Number(item.refundNum)) || Number.isNaN(Number(item.refundPrice)))) {
              numNotValidate = true;
            }
            return {
              saleOrderDetail: {
                id: item.id,
              },
              saleRefundDetail: {
                refundNum: item.refundNum,
                refundReason: item.refundReason,
                wareHouseId: item.wareHouseId,
                wareHouseName: item.wareHouseName,
                locationId: item.locationId,
                locationCode: item.locationCode,
                refundPrice: item.refundPrice, //* 100
              },
            };
          });
          if (saleRefundDetailVoList.length <= 0) {
            noGoods = true;
          }

          data = {
            saleRefundDetailVoList,
            saleRefund: this.saleRefund,
          };
          const saleOrderProceeds = [];
          let hasProceeds = true;
          this.refundList.forEach((item) => {
            const methodData = {};
            methodData.proceedsTypeId = item.proceedsTypeId;
            if (item.proceedsTypeName == '' || item.proceedsTypeName == undefined) {
              if (this.refundData.length <= 0) { // 没有预收款，必须选一个退款方式
                hasProceeds = false;
              }
            }
            if (item.proceedsTypeName != '' && item.proceedsTypeName != undefined) {
              methodData.proceedsTypeName = item.proceedsTypeName;
              methodData.amount = item.amount;
              saleOrderProceeds.push(methodData);
            }
          });
          data.saleOrderProceeds = saleOrderProceeds;

          const financeDepositInfos = [];
          this.refundData.forEach((item) => {
            const refundData = {};
            refundData.financeDepositId = item.financeDepositId;
            refundData.financeDepositDetailId = item.financeDepositDetailId;
            refundData.refundAmount = item.refundAmount;
            financeDepositInfos.push(refundData);
          });
          data.financeDepositInfos = financeDepositInfos;
          if (this.sumMoney != this.refundTotal) {
            this.$Message.error('退款合计不等于退货金额合计，请检查后重新提交');
            return;
          }

          if (!hasProceeds) {
            this.$Message.error('请选择退款方式');
            return;
          }

          if (numNotValidate) {
            this.$Message.error('退货数量或者退货单价请输入正确的数字');
            return;
          }

          if (noGoods) {
            this.$Message.error('请选择商品');
            return;
          }
          if (dataIsNotFull) {
            this.$Message.error('请填写完整数据');
            return;
          }
          this.loading = true;
          afterSale.addReturn(data).then((res) => {
            if (res.data.status == 200) {
              this.$Message.success('保存成功');
              this.resetAll();
              this.jumpToList();
            } else {
              this.$Message.error(res.data.error);
            }
            this.loading = false;
          });
        } else {
          this.$Message.error('请按要求填写');
        }
      });
    },
    resetAll() {
      this.resetTableData();
    },
    jumpToList() {
      this.$router.push({
        name: 'saleRefundList',
      });
    },
    onCancel() {
      this.resetAll();
      this.jumpToList();
    },
    walkTree(dataArr) {
      const res = [];
      dataArr.forEach((item) => {
        item.value = item.warehouseId;
        item.label = item.warehouseName;
        item.children = [];
        item.locationList.forEach((locationItem) => {
          locationItem.value = locationItem.locationId;
          locationItem.label = locationItem.locationCode;
          item.children.push(locationItem);
        });
        res.push(item);
      });
      return res;
    },
    getProceedsTypeList() {
      const tempParams = { status: 1 };
      if (this.tableData.length > 0) {
        tempParams.goodsBaseIdList = this.tableData.map(item => item.goodsBaseId);
      }
      system.getStoreProceedsTypeList(tempParams).then((res) => {
        if (res.status === 200) {
          this.proceedsTypeList = res.data.data.list.filter(item => item.proceedsTypeId !== 6);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleProceedsTypeChange(item, index) {
      if (!item.proceedsTypeId) {
        this.clearIndexMethod(index);
        return;
      }
      const hasCount = this.refundList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId).length;
      this.refundList[index].proceedsTypeName = this.proceedsTypeList.filter(fItem => fItem.proceedsTypeId == item.proceedsTypeId)[0].proceedsTypeName;
      if (hasCount > 1) {
        this.$Message.error('该退款方式已选中，请重新选择');
        this.clearIndexMethod(index);
      }
    },
    clearIndexMethod(index) {
      const tempList = utils.deepClone(this.refundList);
      this.refundList = [];
      tempList[index] = { proceedsTypeId: -1, amount: null, proceedsTypeName: '' };
      setTimeout(() => { // 设置延迟执行才可以，不知道什么原因
        this.refundList = tempList;
        this.priceChange();
      }, 1);
    },
    doChangeGoods() {
      this.changeGoods = false;
      this.resetTableData();
      this.ModalShow = true;
    },
    cancelChangeGoods() {
      this.changeGoods = false;
    },
  },
  mounted() {
    this.getProceedsTypeList();
  },
};
</script>
<style lang="less" scoped>
.temp-img{
  height: 80px;
  width: 80px;
}
.other-card{
  margin-top: 30px;
}
.rejectTable{
  margin-bottom: 16px;
}
.addButton {
  font-weight: 500;
  color: #2d8cf0;;
}
.refundMethod {
  margin-bottom: 6px;
  display: flex !important;
}
.refundInput {
  display: inline !important;
}
.emptySpan {
  width: 93px;
}
</style>
